import React, {useState} from 'react'
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import UiInput from '../../../../_uiMocks/_uiComponents/UiInput';
import { UiButton, UiBackButton } from '../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../_uiComponents/common/UiInnerSearchWr';
import UiCheckbox from '../../../../_uiComponents/common/form/UiCheckBox';
import UiDatePicker from '../../../_uiComponents/UiDatePicker';
import UiSelect from '../../../_uiComponents/UiSelect';
import FormControlLabel from "@mui/material/FormControlLabel";
import UiSwitch from '../../../_uiComponents/UiSwitch';


export default function CreateUsersForm() {
    const [character, setCharacter] = React.useState("");
    const [contains, setContains] = React.useState("");

    const handleChange = (event) => {
         setCharacter(event.target.value);
    };

    let navigate = useNavigate();

    const handleClick = () => {
        //  clear input value
        setContains('');
    };
    const options1 = [
        { value: "value-1", label: "text-1" },
        { value: "value-2", label: "text-2" },
        { value: "value-3", label: "text-3" },
   ];
   

    return (
        <>
            <UiInnerSearchWr>
            <div className='sba-user-form-wr'>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiInput type="text" label="User Email" />  
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiInput type="text" label="Mobile Number" /> 
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiInput type="text" label="First Name" />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiInput type="text" label="Middle Name" />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiInput type="text" label="Last Name" />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiDatePicker label="Date of Birth" />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{mb:2}}
                >
                    <UiSelect label="User Type" 
                            value={character} 
                            handleChange={handleChange}
                            options={options1 }/>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{mb:2}}
                >
                    <UiSelect label="Dealer" 
                            value={character} 
                            handleChange={handleChange}
                            options={options1 }/>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                    sx={{mb:2}}
                >
                    <UiSelect label="Role" 
                            value={character} 
                            handleChange={handleChange}
                            options={options1 }/>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <FormControlLabel
                        control={
                            <UiSwitch name="12" />
                        }
                        label="Active"
                        labelPlacement="top"
                        sx={{
                            mt: 2,
                            ml: 0,
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={6}
                >
                    <UiCheckbox label="Send password set mail" />
                </Grid>
            </Grid>
            </div>

            <Grid container spacing={2}>
                <Grid item xs="12">
                    <Stack spacing={2} direction="row" justifyContent="space-between" alignItems={"center"} sx={{ width: '100%' }}>
                        <UiBackButton size="small" onClick={() => navigate(-1)} />
                        <div className='sbt-right-action-btn-wr'>
                            <UiButton onClick={handleClick} name="Clear" variant="outlined" size="small" />
                            <UiButton name="Update" variant="contained" size="small" />
                        </div>
                    </Stack>
                </Grid>
            </Grid>
        </UiInnerSearchWr>
        </>
    )
}
